export default "__VITE_PUBLIC_ASSET__8fde220a__"